// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"7e0cb29d","389":"3aa9615a","627":"97c1e723"}[chunkId] + ".chunk.js";
};